/**
 * @desc 查询原煤消耗季度计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanQuarterRawCoalResponse>> {
  return defHttp.post({
    url: '/wap/plan/quarter/queryPlanRawCoal',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanQuarterRawCoalResponse>> {
  return defHttp.post({
    url: '/mock/wap/plan/quarter/queryPlanRawCoal',
    data,
  });
}
